import { ArgumentAxis, BarSeries, Chart, ChartProps, Tooltip } from "@devexpress/dx-react-chart-material-ui";
import { Animation, EventTracker, HoverState } from "@devexpress/dx-react-chart";

import { useTheme } from "@mui/material";
import { formatPrice } from "helpers/dataFormat";
import { useState } from "react";

const palette = ["#DFEBFF", "#97B7E1", "#DFEBFF", "#BFD1EA"];

const BarComponent = (props: BarSeries.PointProps) => {
  return <BarSeries.Point {...props} color={palette[props.index]} rx={5} />;
};

const LabeledBarChart = ({
  height,
  data,
  CustomComponent,
}: {
  height?: number;
  data: { title: string; percent: number }[];
  CustomComponent?: (props: BarSeries.PointProps) => JSX.Element;
}) => {
  const [rendered, setRendered] = useState(false);
  const ChartWithChildren = Chart as React.ComponentType<ChartProps & { children: React.ReactNode }>;

  const {
    palette: {
      primary: { main },
    },
  } = useTheme();

  const [hover, setHover] = useState(undefined);
  const [selection, setSection] = useState(undefined);

  const clickItem = ({ targets }: any) => {
    const target = targets[0];
    if (target) {
      setSection(targets);
    }
  };

  const changeHover = (hover: any) => {
    setHover(hover);
  };

  const renderTooltip = (props: any) => {
    return <div>{formatPrice(props.text)}</div>;
  };

  return (
    <div style={{ direction: "ltr" }}>
      <ChartWithChildren data={data} height={height || 350}>
        <ArgumentAxis />
        <BarSeries
          name="Percent"
          valueField="percent"
          pointComponent={CustomComponent || BarComponent}
          barWidth={1}
          argumentField="title"
          color={main}
        />
        <EventTracker onClick={clickItem} />
        <HoverState hover={hover} onHoverChange={changeHover} />
        <Tooltip contentComponent={renderTooltip} />
        <Animation />
      </ChartWithChildren>
    </div>
  );
};

export default LabeledBarChart;
